var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInterbtcLogoWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981.04 249.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".interbtc-horizontal-rgb-1{fill:#1a0a2d;}.interbtc-horizontal-rgb-2{fill:#f90;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M308.84,249.37H95.73a5.49,5.49,0,0,1-2.87-.82L15.86,201a5.47,5.47,0,0,1,2.88-10.13H231.85a5.49,5.49,0,0,1,2.87.82l77,47.53a5.48,5.48,0,0,1-2.88,10.14Zm-211.55-11H289.56l-59.27-36.59H38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M295.58,58.49H82.47a5.53,5.53,0,0,1-2.88-.82L2.6,10.13A5.47,5.47,0,0,1,5.47,0H218.58a5.53,5.53,0,0,1,2.88.82l77,47.53a5.48,5.48,0,0,1-2.88,10.14ZM84,47.54H276.29L217,11H24.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-2",
    d: "M161,121.78c4.41,0,10.24-.49,13.52-3.82a7.53,7.53,0,0,0,2.48-5.74c-.1-7.57-6.37-10.25-12.2-10.23-.48,0-.77,0-.77,0l-8,0,0,19.44,1,.11A35.68,35.68,0,0,0,161,121.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-2",
    d: "M165.37,128.07l-9.3.1.08,22.8h1.12c2.55,0,6.61,0,7.49,0h.79c6.89,0,14.26-3,14.29-11.44a10.17,10.17,0,0,0-2.9-7.51C173.24,128.34,167.15,128.07,165.37,128.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-2",
    d: "M201.05,85.06a55.13,55.13,0,0,0-39.19-15l-.58,0a55.52,55.52,0,0,0,3.1,111l.56,0a55.52,55.52,0,0,0,36.11-96Zm-16.58,69.12a31,31,0,0,1-10.76,2.15h-1.12l-.1,1.13,0,11-8.23,0,0-12.19-8.1.07.05,12.11-8.3,0,0-12.08-13.94.1v-5.4l5.17,0a4,4,0,0,0,3.93-4L142.88,106c0-2-1.63-3.47-3.95-3.47l-5.19-.36,0-7.58h14.07l0-12.49,8.17,0,0,12.51h8.16l0-12.53,8.17,0,0,12.55h1.5c2.82,0,17,2.94,17,14.39,0,12.62-10.58,14-10.76,14.36l-.56,0c.59.07,14.4,2.71,14.3,17.34C193.73,147.05,190.66,151.58,184.47,154.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M396.46,88.82h10.41v12.23H396.46Zm.36,19.86h9.69v59.83h-9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M436.19,108.68h9.69l-.24,16.1h.12c3.27-10.41,11.63-17.07,25.91-17.07,15.75,0,25.07,9.09,25.07,23.37v37.43h-9.68V133.14c0-10.17-5.82-16.71-18.66-16.71-13.68,0-22.52,8.35-22.52,22.65v29.43h-9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M528.25,146.58V117.16h-9.93v-8.48h8c1.94,0,2.67-1,2.91-4.12l.48-9.45h8.24v13.57h21.68v8.48H537.94V146c0,9.09,2.91,14.54,11.87,14.54a33.44,33.44,0,0,0,9.33-1.22v8.24A29.52,29.52,0,0,1,549,169C534.43,169,528.25,159.79,528.25,146.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M636.78,140.53H589.9c.61,12.72,8.36,20.71,20.11,20.71,10,0,17-5.08,17.8-13h9c-.61,13-11.14,21.19-26.89,21.19-18,0-29.67-11.87-29.67-30.4,0-19.14,11.5-31.37,29.43-31.37,17.07,0,27.13,10.54,27.13,28.34Zm-9-7.75c0-10.54-6.53-16.83-17.92-16.83-10.66,0-17.81,6.18-19.62,17.55h37.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M663.43,108.68h9.69L672.88,126H673c2.79-10.42,9-18.29,21.8-18.29,13.45,0,20.59,9,20.59,23.37a106.68,106.68,0,0,1-.6,10.66h-8.85a66.73,66.73,0,0,0,.49-8.6c0-11-4.12-16.71-13.93-16.71-12.23,0-19.38,10.66-19.38,25.56v26.52h-9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M739,88.82h35.13c18.77,0,29.91,7.75,29.91,20.83,0,8.84-4.24,15.13-11.39,17.07v.13c8.61,1.93,14.42,8.36,14.42,18.41,0,14.65-10.3,23.25-30.4,23.25H739Zm36.46,33.06c7.14,0,11.14-3.15,11.14-9.08s-4-9.57-12.6-9.57H758.88v18.65Zm1.21,32.22c7.26,0,11.51-4.12,11.51-10.91,0-5.56-4.36-9.32-12-9.32H758.88V154.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M845.37,104.44H822.72V88.82h65v15.62H865.24v64.07H845.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-horizontal-rgb-1",
    d: "M902,128.78c0-25.91,17.44-41.17,42-41.17,21.81,0,36.82,12.35,36.82,30.64,0,1.81-.12,4-.23,5.08H963.23c.12-1.33.12-2.54.12-3.14,0-10.78-7.62-17-18.41-17-13.08,0-22.4,9.81-22.4,25.55s9.57,25.32,22.4,25.32c11.63,0,18.66-6.3,18.66-16.35a25.22,25.22,0,0,0-.12-2.54h17.44c.12,1.57.12,2.9.12,3.87,0,18.29-15.14,30.64-37.07,30.64C919.39,169.72,902,154.46,902,128.78Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterbtcLogoWithText);
export default __webpack_public_path__ + "static/media/interbtc-logo-with-text.c5391f31.svg";
export { ForwardRef as ReactComponent };